// extracted by mini-css-extract-plugin
export default {"mainContainer":"Employees_mainContainer__bXuLG","noEmployeeDiv":"Employees_noEmployeeDiv__k-P7R","noEmployeeText":"Employees_noEmployeeText__G5CMF"};